/* eslint-disable no-unused-expressions */
import React, { useState } from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';

import Image from '../../../../core-components/Image';
import { getErrorMessage, jwtParser } from '../../../../utils/utilities';
import localStorage from '../../../../api/localStorage';
import AppConstants from '../../../../core-components/AppConstants';

import styles from './DropdownMenu.module.scss';
import { Link } from 'react-router-dom';

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <Button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </Button>
));

const CustomMenu = React.forwardRef(
  ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
    let newStyle = {
      bottom: 'auto',
      left: '0',
      position: 'absolute',
      right: 'auto',
      top: '0',
      transform: 'translate3d(-300.6666666666667px, 50px, 0)'
    };
    return (
      <div ref={ref} style={newStyle} className={className}>
        <div>{React.Children.toArray(children)}</div>
      </div>
    );
  }
);

export default ({ title, company, ...props }) => {
  const token = localStorage.getToken();
  const parsedJwtDetail = jwtParser(token);

  return title ? (
    <div className={styles.userProfile}>
      <Dropdown className={styles.mainDropdown}>
        <Dropdown.Toggle as={CustomToggle} id='dropdown-custom-components'>
          {title && title.charAt(0)}
        </Dropdown.Toggle>
        <Dropdown.Menu as={CustomMenu} className={styles.dropdownMenu}>
          <div className={styles.dropdownMenuHeader}>
            <div className={styles.userInitial}>{title && title.charAt(0)}</div>
            <div className={styles.userDetails}>
              <div className={styles.name}>{title}</div>
              <div>
                <Link className={styles.myProfile} to={{ pathname: '/profile' }}>
                  {'My Profile'}
                </Link>
              </div>
            </div>
          </div>
          {props?.isAdmin ? (
            <>
              {props?.paymentDetails?.userEmailBounceData?.count ? (
                <Dropdown.Item
                  className={`${styles.dropdownParticularCard} ${styles.adminBounceEmailBanner}`}
                  onClick={() => props.history.push('/myTeam')}
                >
                  <div className={styles.dropdownParticular}>
                    <Image name={'myTeamIconWhite.svg'} />
                    <span className={styles.userSectionDetails}>
                      <div style={{ display: 'flex' }}>
                        <p className={styles.userSectionHeader}>{'My team'}</p>
                        <Image name={'whiteWarning.svg'} style={{ marginLeft: '3px' }} />
                      </div>
                      <p className={styles.userSectionDescription}>{'Manage team users'}</p>
                    </span>
                  </div>
                </Dropdown.Item>
              ) : (
                <Dropdown.Item
                  className={styles.dropdownParticularCard}
                  onClick={() => props.history.push('/myTeam')}
                >
                  <div className={styles.dropdownParticular}>
                    <Image name={'myTeamIcon.svg'} />
                    <span className={styles.userSectionDetails}>
                      <p className={styles.userSectionHeader}>{'My team'}</p>
                      <p className={styles.userSectionDescription}>{'Manage team users'}</p>
                    </span>
                  </div>
                </Dropdown.Item>
              )}
              <Dropdown.Item
                className={styles.dropdownParticularCard}
                onClick={() => props.history.push('/manageTags')}
              >
                <div className={styles.dropdownParticular}>
                  <Image name={'manageTagsIcon.svg'} />
                  <span className={styles.userSectionDetails}>
                    <p className={styles.userSectionHeader}>{'Manage tags'}</p>
                    <p className={styles.userSectionDescription}>
                      {'Add, edit or delete tags for candidates'}
                    </p>
                  </span>
                </div>
              </Dropdown.Item>
              <Dropdown.Item
                className={styles.dropdownParticularCard}
                onClick={() => props.history.push('/manageCategories')}
              >
                <div className={styles.dropdownParticular}>
                  <Image name={'manageCategoriesIcon.svg'} />
                  <span className={styles.userSectionDetails}>
                    <p className={styles.userSectionHeader}>{'Manage categories'}</p>
                    <p className={styles.userSectionDescription}>
                      {'Add, edit or delete categories'}
                    </p>
                  </span>
                </div>
              </Dropdown.Item>
              {parsedJwtDetail?.data?.modelType?.includes('PREPAID') && props?.isAdmin && (
                /**
                 * This block has been commented as per the feature ADO-3138
                 * 
                <>
                  <Dropdown.Item
                    className={styles.dropdownParticularCard}
                    href={`${AppConstants.baseURL}purchaseHistory`}
                  >
                    <div className={styles.dropdownParticular}>
                      <Image name={'purchaseHistoryIcon.svg'} />
                      <span className={styles.userSectionDetails}>
                        <p className={styles.userSectionHeader}>{'Purchase history'}</p>
                        <p className={styles.userSectionDescription}>
                          {'Check packages & credits purchased'}
                        </p>
                      </span>
                    </div>
                  </Dropdown.Item>
                  <Dropdown.Item
                    className={styles.dropdownParticularCard}
                    href={`${AppConstants.baseURL}credits`}
                  >
                    <div className={styles.dropdownParticular}>
                      <Image name={'creditsIcon.svg'} />
                      <span className={styles.userSectionDetails}>
                        <p className={styles.userSectionHeader}>{'Credits'}</p>
                        <p className={styles.userSectionDescription}>
                          {'Add credits, check balance & transaction'}
                        </p>
                      </span>
                    </div>
                  </Dropdown.Item>
                </>
                 **/
                <Dropdown.Item
                  className={styles.dropdownParticularCard}
                  onClick={() => props.history.push('/transaction')}
                >
                  <div className={styles.dropdownParticular}>
                    <div className={styles.transactionIcon}>
                      <Image width='25px' height='29px' name={'transactions.png'} />
                    </div>
                    <span className={styles.userSectionDetails}>
                      <p className={styles.userSectionHeader}>{'Transactions'}</p>
                      <p className={styles.userSectionDescription}>
                        {'Add credits, track payments and usage'}
                      </p>
                    </span>
                  </div>
                </Dropdown.Item>
              )}
            </>
          ) : null}
          <div className={styles.bulkUploadItemContainer}>
            <div className={styles.customTooltipContainer}>
              <div className={styles.customTooltip}>
                <div className={styles.bcTT}>This option has moved to the Add Candidate Button</div>
                <Dropdown.Item
                  className={styles.addCandidateLink}
                  onClick={() => props.history.push('/candidates?showCandidateTooltip=yes')}
                >
                  Take me there
                </Dropdown.Item>
              </div>
            </div>
            {/* <Dropdown.Item
              className={styles.dropdownParticularCard + ' ' + styles.disabledItem}
              disabled={true}
            >
              <div className={styles.dropdownParticular}>
                <Image name={'bulkCandidateNew.svg'} />
                <span className={styles.userSectionDetails}>
                  <p className={styles.userSectionHeader}>{'Bulk Candidate Addition'}</p>
                  <p className={styles.userSectionDescription}>
                    {'Upload multiple candidates at once'}
                  </p>
                </span>
              </div>
            </Dropdown.Item> */}
          </div>
          {props?.isAdmin ? (
            /* API token Generation can only be done by CA-Admin */
            <Dropdown.Item
              className={styles.dropdownParticularCard}
              onClick={() => props.history.push('/settings')}
            >
              <div className={styles.dropdownParticular}>
                <Image
                  style={{ height: '45px', width: '29px', padding: '6px 0px' }}
                  name={'settings.png'}
                />
                <span className={styles.userSectionDetails}>
                  <p className={styles.userSectionHeader}>{'Settings'}</p>
                  <p className={styles.userSectionDescription}>
                    {'Manage company and users settings'}
                  </p>
                </span>
              </div>
            </Dropdown.Item>
          ) : null}
          {props?.isAdmin ? (
            /* Integrations can only be done by CA-Admin */
            <Dropdown.Item
              className={styles.dropdownParticularCard}
              onClick={() => props.history.push('/integrations')}
            >
              <div className={styles.dropdownParticular}>
                <Image name={'integrations.svg'} />
                <span className={styles.userSectionDetails}>
                  <p className={styles.userSectionHeader}>{'Integrations'}</p>
                  <p className={styles.userSectionDescription}>{'Integrate to SpringVerify'}</p>
                </span>
              </div>
            </Dropdown.Item>
          ) : null}
          <Dropdown.Item
            className={styles.dropdownParticularCard}
            onClick={() => props.history.push('/exportCases')}
          >
            <div className={styles.dropdownParticular}>
              <Image name={'exportCasesIcon.svg'} />
              <span className={styles.userSectionDetails}>
                <p className={styles.userSectionHeader}>{'Export cases'}</p>
                <p className={styles.userSectionDescription}>{'Export candidate data to Excel'}</p>
              </span>
            </div>
          </Dropdown.Item>
          <Dropdown.Item
            className={styles.dropdownParticularCard}
            onClick={() => props.history.push('/changePassword')}
          >
            <div className={styles.dropdownParticular}>
              <Image name={'changePasswordIcon.svg'} />
              <span className={styles.userSectionDetails}>
                <p className={styles.userSectionHeader}>{'Change Password'}</p>
                <p className={styles.userSectionDescription}>{'Change your password'}</p>
              </span>
            </div>
          </Dropdown.Item>
          <div className={styles.dropdownParticularCard}>
            <div className={styles.signOutBtn} onClick={() => props.history.push('/logout')}>
              {'Sign Out'}
            </div>
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  ) : (
    <div />
  );
};
